import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  fontSize,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionMargins,
  standardColours,
  standardTransition,
  visuallyHidden,
} from '../styles';
import { Container, Link, Svg } from './ui';
import navArrow from '../images/arrow-right.inline.svg';

const StyledSalesforceExplainerNav = styled.section`
  ${sectionMargins(undefined, '100px')}
`;

const StyledInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

//moved up for hover
const StyledArrowIconWrapper = styled.div`
  position: relative;
  width: 48px;
  height: 48px;
  border: solid 1px ${standardColours.black};
  border-radius: 50%;
  padding: 14px;
  transition: ${standardTransition('border-color')};

  ${minBreakpointQuery.small`
    width: 60px;
    height: 60px;
    padding: 17px;
  `}
`;

//moved up for hover
const StyledArrowIcon = styled(Svg)`
  transition: ${standardTransition('fill')};
  width: 20px;
  height: 20px;

  ${minBreakpointQuery.small`
    width: 24px;
    height: 24px;
  `}

  ${({ alt }) => {
    if (alt) {
      return css`
        transform: rotate(180deg);
      `;
    }
  }}
`;

const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 48px;
  transition: ${standardTransition('color')};

  &:hover {
    color: ${brandColours.tertiary};

    ${StyledArrowIconWrapper} {
      border-color: ${brandColours.tertiary};
    }

    ${StyledArrowIcon} {
      fill: ${brandColours.tertiary};
    }
  }
`;

const StyledLinkText = styled.span`
  ${maxBreakpointQuery.small`
    ${visuallyHidden()};
  `}

  ${minBreakpointQuery.small`
    ${fontSize(18)}
  `}
`;

const StyledLink = styled(Link)`
  transition: ${standardTransition('color')};

  ${minBreakpointQuery.small`
    ${fontSize(18)}
  `}

  &:hover {
    color: ${brandColours.tertiary};
  }
`;

const SalesforceExplainerNav = ({ link, currentPage, items }) => {
  const currentIndex = items.findIndex(item => item.slug === currentPage);

  const prevLink =
    currentIndex === 0 ? items[items.length - 1] : items[currentIndex - 1];
  const nextLink =
    currentIndex === items.length - 1 ? items[0] : items[currentIndex + 1];

  return (
    <StyledSalesforceExplainerNav>
      <Container>
        <StyledInner>
          <NavLink to={prevLink} title={prevLink.title}>
            <StyledArrowIconWrapper>
              <StyledArrowIcon image={navArrow} alt={true} />
            </StyledArrowIconWrapper>
            <StyledLinkText>Previous</StyledLinkText>
          </NavLink>
          <StyledLink to={link}>Back to view all</StyledLink>
          <NavLink to={nextLink} title={nextLink.title}>
            <StyledLinkText>Next</StyledLinkText>
            <StyledArrowIconWrapper>
              <StyledArrowIcon image={navArrow} />
            </StyledArrowIconWrapper>
          </NavLink>
        </StyledInner>
      </Container>
    </StyledSalesforceExplainerNav>
  );
};

export default SalesforceExplainerNav;
